import {
  apiGetActivePartnerPopup,
  apiRecordPartnerPopupCtaClick,
  apiRecordPartnerPopupView,
} from '@/api/partnerPopups';

export default {
  namespaced: true,

  state: () => ({
    popup: null,
    open: false,
    fetched: false,
  }),

  getters: {
    activePartnerPopup: (state) => state.popup,
    isPartnerPopupOpen: (state) => state.open && !!state.popup,
  },

  mutations: {
    setPopup(state, popup) {
      state.popup = popup;
    },
    setOpen(state, open) {
      state.open = open;
    },
    setFetched(state, fetched) {
      state.fetched = fetched;
    },
  },

  actions: {
    async loadActivePopup({ state, commit }) {
      if (state.fetched) return;
      commit('setFetched', true);
      try {
        const popup = await apiGetActivePartnerPopup();
        if (!popup) return;
        commit('setPopup', popup);
        commit('setOpen', true);
      } catch (e) {
        commit('setPopup', null);
      }
    },

    async recordView({ state }) {
      if (!state.popup) return;
      try {
        await apiRecordPartnerPopupView(state.popup.id);
      } catch (e) {
        // ignore
      }
    },

    async recordCtaClick({ state }) {
      if (!state.popup) return;
      try {
        await apiRecordPartnerPopupCtaClick(state.popup.id);
      } catch (e) {
        // ignore
      }
    },

    closePopup({ commit }) {
      commit('setOpen', false);
    },
  },
};
